import { Appearance } from 'react-native';

export type ThemeMode = 'light' | 'dark' | 'dynamic';

/**
 * Determines if dark mode should be enabled based on themeMode setting
 * - 'dark': Always dark
 * - 'light': Always light
 * - 'dynamic': Use device preference
 */
export function shouldUseDarkMode(themeMode: ThemeMode | string | undefined): boolean {
    if (!themeMode) return false;
    
    if (themeMode === 'dark') {
        return true;
    }
    
    if (themeMode === 'dynamic') {
        // Get device color scheme preference
        const colorScheme = Appearance.getColorScheme();
        return colorScheme === 'dark';
    }
    
    // 'light' or any other value
    return false;
}

/**
 * Subscribe to device theme changes (for dynamic mode)
 * Returns an unsubscribe function
 */
export function subscribeToThemeChanges(
    themeMode: ThemeMode | string | undefined,
    onThemeChange: (isDark: boolean) => void
): (() => void) | null {
    if (themeMode !== 'dynamic') {
        return null;
    }

    const subscription = Appearance.addChangeListener(({ colorScheme }) => {
        onThemeChange(colorScheme === 'dark');
    });

    return () => subscription.remove();
}
